import script from "./ProgressModuleGridFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressModuleGridFooter.vue?vue&type=script&setup=true&lang=js"

import "./ProgressModuleGridFooter.vue?vue&type=style&index=0&id=5da147f6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da147f6"]])

export default __exports__